import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { WorksheetEntryService } from '@pbx/services/WorksheetEntryService';
import { WorksheetActionService } from '@pbx/services/WorksheetActionService';

class WorksheetItemServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  createItem(type, worksheet_id, params) {
    if (type === 'entry') {
      return WorksheetEntryService.createItem(worksheet_id, params);
    } else {
      return WorksheetActionService.createItem(worksheet_id, params);
    }
  }

  getItem(type, worksheet_id, id) {
    if (type === 'entry') {
      return WorksheetEntryService.getItem(worksheet_id, id);
    } else {
      return  WorksheetActionService.getItem(worksheet_id, id);
    } 
  }

  updateItem(type, worksheet_id, id, params) {
    if (type === 'entry') {
      return WorksheetEntryService.updateItem(worksheet_id, id, params);
    } else {
      return WorksheetActionService.updateItem(worksheet_id, id, params);
    }
  }

  removeItem(type, worksheet_id, id) {
    if (type === 'entry') {
       return WorksheetEntryService.removeItem(worksheet_id, id);      
    } else {
      return WorksheetActionService.removeItem(worksheet_id, id);
    }
  }

  createOrUpdateItem(type, worksheet_id, id, params) {
    if (type === 'entry') {
      return WorksheetEntryService.createOrUpdateItem(worksheet_id, id, params);
    } else {
      return WorksheetActionService.createOrUpdateItem(worksheet_id, id, params);
    }
  }

  savePosition(type, worksheet_id, id, { position_x, position_y }) {
    return this.updateItem(type, worksheet_id, id, { position_x, position_y });
  }

  updateData(type, worksheet_id, id, data) {
    if (type === 'entry') {
      return this.updateItem(type, worksheet_id, id, data);
    } else {
       return this.updateItem(type, worksheet_id, id, { data: data });
    }
  }
}

export const WorksheetItemService = new WorksheetItemServiceClass({
  api_version: 2,
  resource: ''
});
